// GiftCard.tsx
import React from "react";
import classes from "./GiftCard.module.scss";

type GiftCardProps = {
  image: string;
  title: string;
  point: number;
  effectiveFrom: string;
  effectiveTo: string;
  onClick?: () => void;
  showDisclaimer?: boolean;
};

const formatDate = (date: string) => {
  return date.replace(/-/g, "/");
};

const GiftCard: React.FC<GiftCardProps> = ({
  image,
  title,
  point,
  effectiveFrom,
  effectiveTo,
  onClick,
  showDisclaimer = false,
}) => {
  return (
    <div className={classes.giftBlock} onClick={onClick}>
      <div className={classes.giftItem}>
        <div className={classes.rewardImage}>
          <img src={image} alt="ギフトイメージ" />
        </div>
        <div className={classes.rewardRow}>
          <div className={classes.rewardTitle}>{title}</div>
          <div className={classes.rewardInfo}>
            <span className={classes.rewardName}>✦ みらいいポイント</span>
            <span className={classes.point}>{point.toLocaleString("ja-JP")}</span>
            <span className={classes.text}>ptで交換可能</span>
          </div>
          <div className={classes.exchangePeriod}>
            交換期間 {formatDate(effectiveFrom)} ~ {formatDate(effectiveTo)}
          </div>
          {showDisclaimer && (
            <>
              <hr className={classes.disclaimerDivider} />
              <p className={classes.disclaimer}>
                ※本キャンペーンは株式会社miraiiによる提供です。
                <br />
                本キャンペーンについてのお問い合わせはAmazonではお受けしておりません。
                <br />
                ※Amazon、Amazon.co.jpおよびそれらのロゴはAmazon.com, Inc.
                またはその関連会社の商標です。
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default GiftCard;
